'use client';
import { styled } from 'styled-components';
import { HtmlContentStyle } from './styles';
import { htmlContentAdditionalStyles } from '../htmlStyle';
export const HtmlContentWrapperWithStyle = styled.div `
  word-break: break-word;
  overflow-wrap: break-word;
  max-width: 100%;

  ${htmlContentAdditionalStyles()}

  ${({ theme }) => HtmlContentStyle(theme)}
`;
//# sourceMappingURL=HtmlContentWrapperWithStyle.js.map